/****************************************************
 * Module Name:  columnOrderSettingsMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState, useEffect } from 'react';
import DraggableList from './DraggableList';
import UserColumnPermissionProxy from '../../utility/proxy/manager/permissionProxy/userColumnPermissionProxy';
import Constants from '../../utility/constants';
import PageTitle from '../common/pageTitle';

const ColumnOrderSettingsMaster = () => {
    const [columnOption, setColumnOption] = useState([]);

    useEffect(() => {
        PageTitle("SETTING_COLUMN_ORDER_SETTING");
        getAllUserColumnPermission();
    }, []);

    const getAllUserColumnPermission = () => {
        UserColumnPermissionProxy.GetColumnNameForUser(Constants.loggedInUser.id, (response) => {
            if (response) {
                setColumnData(response)
            } else {
            }
        }
        );
    };

    const setColumnData = (response) => {
        let columns = []
        response.map((columnname, idx) => {
            let index = idx + 1;
            let column = {
                id: "item-" + index,
                content: index + " " + columnname,
                label: columnname
            }
            columns.push(column);

            return true;
        })
        setColumnOption(columns);
    };

    return (
        <div>
            {columnOption.length > 0 && <DraggableList items={columnOption} />}
        </div>
    );
};

export default ColumnOrderSettingsMaster;
